import { render, staticRenderFns } from "./ModalListaCursoFuncionario.vue?vue&type=template&id=572d850e"
import script from "./ModalListaCursoFuncionario.vue?vue&type=script&lang=js"
export * from "./ModalListaCursoFuncionario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports